import { FinancialProduct } from './../model/combos-model';
import {
  ParticipantDTO,
  RequestDataReponseDTO,
  CalculatorResponseDTO,
  RequestFormDTO,
  RequestFormInstantCreditDTO,
  PrintContractDTO,
  AuthorizationDTO,
  AuthorizationPapyrusDTO,
  Operation,
} from '../model/requests-model';
import { Injectable } from '@angular/core';

import { RequestsSaveSendApi } from './requests-save-send-api.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';

import {
  FORM_BP,
  POINT_OF_SALE,
  HOLDER_DATA,
  CONTACT_DATA,
  SOCIOECONOMIC_DATA,
  DIRECT_DEBIT,
  REQUEST_OBSERVATIONS,
  REQUEST_DATA,
  INSURANCE,
  FORM_CONSUMO,
  FORM_REPSOL,
  FORM_GS,
  FORM_MG_NO_SHOP,
  FORM_MG,
  FINANCE,
  FORM_AUTO,
  INTERVINIENTE_1_HOLDER_DATA,
  REQUEST_DATA_MG,
  APROBADAS,
  PENDIENTES_DE_DATOS,
  EN_ESTUDIO,
  FIRMADAS,
  DENEGADAS,
  FORM_IC,
  REQUEST_BASIC_CONTACT,
  FINANCE_AMOUNT,
  PRESCRIBER_CONTACT_DATA,
  BRAND_AUTOS,
  BRAND_PAPYRUS_CONSUMO,
  BRAND_PAPYRUS_CREDICUENTAS,
  BRAND_PAPYRUS_PRESTAMO_PERSONAL,
  BRAND_PAPYRUS_PRESTAMO_REESTRUCTURADO,
  VERSION_PRESTAMO_REESTRUCTURADO,
  BRAND_AUTOS_LEASING,
  FIRMADAS_STATUS_75,
} from '@app/@core/constants/requests.constants';
import { FINANCIAL_PRODUCT } from '@app/@core/constants/logalty-digital-signature.constants';
import { TestRequestDialogComponent } from '@app/@shared/dialogs/test-request/test-request.component';
import { CredentialsService } from '@app/@core/auth';
import { PrintStore } from '@app/@shared';

@Injectable()
export class RequestsSaveSendStore {
  private marcaFormulario: string;

  //Variables necesarias para todos los formularios
  public numOperation: string;
  public numOperationIC: string = '';
  public optionTest: boolean;
  public optionTestAccept: string;
  public codeVersionOperative: string;
  public formReset: boolean = false;

  public enviarPeticionSource = new BehaviorSubject<boolean>(false);
  public enviarPeticion$ = this.enviarPeticionSource.asObservable();

  public savePeticionSource = new BehaviorSubject<boolean>(false);
  public savePeticion$ = this.savePeticionSource.asObservable();

  public financialProduct = new BehaviorSubject<string>('');
  public financialProduct$ = this.financialProduct.asObservable();

  public numOperationAuth = new BehaviorSubject<string>('');
  public numOperationAuth$ = this.numOperationAuth.asObservable();

  public resetFormsSource = new BehaviorSubject<boolean>(false);
  public resetForms$ = this.resetFormsSource.asObservable();

  public firstStepSource = new BehaviorSubject<boolean>(false);
  public firstStepSource$ = this.firstStepSource.asObservable();

  public secondStepSource = new BehaviorSubject<boolean>(false);
  public secondStepSource$ = this.secondStepSource.asObservable();

  public thirdStepSource = new BehaviorSubject<boolean>(false);
  public thirdStepSource$ = this.thirdStepSource.asObservable();

  private contactDataFormSource = new BehaviorSubject<FormGroup>(new FormGroup({}));
  public contactDataForm$ = this.contactDataFormSource.asObservable();

  private calculatorSource = new BehaviorSubject<boolean>(false);
  public isCalculatorData$ = this.calculatorSource.asObservable();

  private financeAmountSource = new BehaviorSubject<FormGroup>(null);
  public isFinanceAmountData$ = this.financeAmountSource.asObservable();

  private requestDataUptakeSource = new BehaviorSubject<FormGroup>(null);
  public requestDataUptakeSource$ = this.requestDataUptakeSource.asObservable();

  private financingSource = new BehaviorSubject<any>(null);
  public financingData$ = this.financingSource.asObservable();

  private checkContactDataSource = new BehaviorSubject<boolean>(false);
  public isCheckContactData$ = this.checkContactDataSource.asObservable();

  public dniHolder = new BehaviorSubject<string>('');
  public changeDniHolder$ = this.dniHolder.asObservable();

  public dniListIntervinients = new BehaviorSubject<any[]>([]);
  public changeDniListIntervinients$ = this.dniListIntervinients.asObservable();

  public videoSelfingID = new BehaviorSubject<string>('');
  public videoSelfingID$ = this.videoSelfingID.asObservable();

  public controlNoMovil = new BehaviorSubject<boolean>(null);
  public controlNoMovil$ = this.controlNoMovil.asObservable();

  public valueCheckVideoSelfing = new BehaviorSubject<boolean>(null);
  public valueCheckVideoSelfing$ = this.valueCheckVideoSelfing.asObservable();

  public controlNoEmail = new BehaviorSubject<boolean>(null);
  public controlNoEmail$ = this.controlNoEmail.asObservable();

  public importeMaxVideoSelfing = new BehaviorSubject<string>('');
  public importeMaxVideoSelfing$ = this.importeMaxVideoSelfing.asObservable();

  public listaFormulariosBonpreu: FormGroup[] = [];
  public listaFormulariosAutos: FormGroup[] = [];
  public listaFormulariosConsumo: FormGroup[] = [];
  public listaFormulariosMgNoShopping: FormGroup[] = [];

  public listaFormulariosMg: FormGroup[] = [];
  public numIntervinientes: number = 0;
  private operative: string;
  private request: any;

  //para el formulario de mango con compra
  private financingDtoMg: CalculatorResponseDTO;

  constructor(
    private requestsApi: RequestsSaveSendApi,
    private translate: TranslateService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private credentialsService: CredentialsService,
    private printStore: PrintStore
  ) {}

  public setCheckContactData(value: boolean) {
    this.checkContactDataSource.next(value);
  }

  public setFinancingDtoMg(financing: CalculatorResponseDTO) {
    this.financingDtoMg = financing;
  }

  public setFormularioBonpreu(form: FormGroup, id: number) {
    this.listaFormulariosBonpreu[id] = form;
  }

  public setFormularioAutos(form: FormGroup, id: number) {
    this.listaFormulariosAutos[id] = form;
  }

  public setFormularioMangoNoShopping(form: FormGroup, id: number) {
    this.listaFormulariosMgNoShopping[id] = form;
  }

  public setFormularioMg(form: FormGroup, id: number) {
    this.listaFormulariosMg[id] = form;
  }

  public setFormularioConsumo(form: FormGroup, id: number) {
    this.listaFormulariosConsumo[id] = form;
  }

  public getMarcaFormulario(): string {
    return this.marcaFormulario;
  }

  public setMarcaFormulario(nuevaMarca: string): void {
    this.marcaFormulario = nuevaMarca;
  }

  public setDNIHolder(value: string) {
    this.dniHolder.next(value);
  }

  public setNumOperationAuth(value: string) {
    this.numOperationAuth.next(value);
  }
  public setVideoSelfingID(value: string) {
    this.videoSelfingID.next(value);
  }

  public getVideoSelfingID() {
    return this.videoSelfingID.value;
  }

  public getControlNoEmail() {
    return this.controlNoEmail.value;
  }

  public getvalueCheckVideoSelfing() {
    return this.valueCheckVideoSelfing.value;
  }

  public setvalueCheckVideoSelfing(value: boolean) {
    this.valueCheckVideoSelfing.next(value);
  }

  public getControlNoMovil() {
    return this.controlNoMovil.value;
  }

  public setControlNoMovil(value: boolean) {
    this.controlNoMovil.next(value);
  }

  public setControlNoEmail(value: boolean) {
    this.controlNoEmail.next(value);
  }

  public setImporteMaxVideoSelfing(value: string) {
    this.importeMaxVideoSelfing.next(value);
  }

  public setDniListIntervinients(value: string, index: number) {
    if (value == null && index != -1) {
      this.dniListIntervinients.next(null);
    } else {
      let listDnis = this.dniListIntervinients.value;

      let indexExist = listDnis.findIndex((dni) => dni.index == index);
      if (indexExist >= 0) listDnis.splice(indexExist, 1);

      if (value != '') listDnis.push({ value, index });

      this.dniListIntervinients.next(listDnis);
    }
  }

  public setContactDataForm(form: FormGroup) {
    this.contactDataFormSource.next(form);
  }

  public setCalculatorData(value: boolean) {
    this.calculatorSource.next(value);
  }

  public getFinancingData(): any {
    return this.financingSource.getValue();
  }

  public setFinancingData(value: any) {
    this.financingSource.next(value);
  }

  public getCalculatorData(): boolean {
    return this.calculatorSource.getValue();
  }

  public setFinanceAmountData(value: FormGroup) {
    this.financeAmountSource.next(value);
  }

  public getFinanceAmountData(): FormGroup {
    return this.financeAmountSource.getValue();
  }

  public setRequestDataUptake(value: FormGroup) {
    this.requestDataUptakeSource.next(value);
  }

  public getRequestDataUptake(): FormGroup {
    return this.requestDataUptakeSource.getValue();
  }

  public chekDuplicatedDNI(dni: string): boolean {
    let duplicated = false;

    if (dni != '') {
      let listTemp = [...this.dniListIntervinients.value];
      listTemp.push({ value: this.dniHolder.value, id: 0 });

      listTemp.forEach((dniList) => {
        if (dniList.value == dni) duplicated = true;
      });
    }

    return duplicated;
  }

  public checkDuplicatedPhone(): boolean {
    let listaFormularios: FormGroup[];
    let arrayPhones: string[] = [];

    switch (this.marcaFormulario) {
      case FORM_BP:
        listaFormularios = this.listaFormulariosBonpreu;
        break;
      case FORM_AUTO:
        listaFormularios = this.listaFormulariosAutos;
        break;
      case FORM_CONSUMO:
      case FORM_REPSOL:
      case FORM_GS:
        listaFormularios = this.listaFormulariosConsumo;
        break;
      case FORM_MG:
        listaFormularios = this.listaFormulariosMg;
        break;
      case FORM_MG_NO_SHOP:
        listaFormularios = this.listaFormulariosMgNoShopping;
        break;
      default:
        console.log('Error');
    }

    listaFormularios.forEach((form: FormGroup) => {
      let phone: string;
      let nophone: boolean;
      if (form) {
        Object.keys(form.controls).forEach((key) => {
          if (key == 'phone') {
            phone = form.controls[key].value;
          }

          if (key == 'nophone') {
            nophone = form.controls[key].value;
          }
        });

        if (!nophone && phone) {
          arrayPhones.push(phone);
        }
      }
    });
    console.log('teléfonos: ', arrayPhones);

    const duplicated = arrayPhones.some((phone) => {
      let counter = 0;
      for (const iterator of arrayPhones) {
        if (iterator === phone) {
          counter += 1;
        }
      }
      return counter > 1;
    });

    console.log('Duplicados?: ', duplicated);

    return duplicated;
  }

  public setFormReset(value: boolean) {
    this.formReset = value;
  }

  public resetForms(request: string) {
    if (request === FORM_BP) {
      this.listaFormulariosBonpreu.forEach((form) => {
        if (form) {
          form.reset();
          form.updateValueAndValidity();
        }
      });

      console.log('formulario BP: ', this.listaFormulariosBonpreu);

      this.listaFormulariosBonpreu[SOCIOECONOMIC_DATA].controls.job.disable();
      this.listaFormulariosBonpreu[SOCIOECONOMIC_DATA].controls.enterpriseActivity.disable();
      this.listaFormulariosBonpreu[SOCIOECONOMIC_DATA].controls.cnae.disable();
    } else if (request === FORM_MG_NO_SHOP) {
      this.listaFormulariosMgNoShopping.forEach((form) => {
        if (form) {
          form.reset();
          form.updateValueAndValidity();
        }
      });

      this.listaFormulariosMgNoShopping[SOCIOECONOMIC_DATA].controls.job.disable();
      this.listaFormulariosMgNoShopping[SOCIOECONOMIC_DATA].controls.enterpriseActivity.disable();
      this.listaFormulariosMgNoShopping[SOCIOECONOMIC_DATA].controls.cnae.disable();
    } else if (request === FORM_MG) {
      this.listaFormulariosMg.forEach((form) => {
        if (form) {
          form.reset();
          form.updateValueAndValidity();
        }
      });

      this.listaFormulariosMg[SOCIOECONOMIC_DATA].controls.job.disable();
      this.listaFormulariosMg[SOCIOECONOMIC_DATA].controls.enterpriseActivity.disable();
      this.listaFormulariosMg[SOCIOECONOMIC_DATA].controls.cnae.disable();
    } else if (request === FORM_AUTO) {
      this.listaFormulariosAutos.forEach((form) => {
        if (form) {
          form.reset();
          form.updateValueAndValidity();
        }
      });

      this.listaFormulariosAutos[SOCIOECONOMIC_DATA].controls.job.disable();
      this.listaFormulariosAutos[SOCIOECONOMIC_DATA].controls.enterpriseActivity.disable();
      this.listaFormulariosAutos[SOCIOECONOMIC_DATA].controls.cnae.disable();
    } else if (request === FORM_CONSUMO) {
      this.listaFormulariosConsumo.forEach((form) => {
        if (form) {
          form.reset();
          form.updateValueAndValidity();
        }
      });

      this.formReset = true;

      this.listaFormulariosConsumo[SOCIOECONOMIC_DATA].controls.job.disable();
      this.listaFormulariosConsumo[SOCIOECONOMIC_DATA].controls.enterpriseActivity.disable();
      this.listaFormulariosConsumo[SOCIOECONOMIC_DATA].controls.cnae.disable();
    }
  }

  public setEnviarPeticion(valor: boolean): void {
    this.enviarPeticionSource.next(valor);
  }

  public setFirstStep(valor: boolean): void {
    this.firstStepSource.next(valor);
  }

  public setSecondStep(valor: boolean): void {
    this.secondStepSource.next(valor);
  }

  public setFinancialProduct(valor: string): void {
    this.financialProduct.next(valor);
  }

  public setThirdStep(valor: boolean): void {
    this.thirdStepSource.next(valor);
  }

  public convertFormToRequestFormDTO(
    request_type: string,
    dataDialogPass: any,
    numOperation?: string,
    hostStatus?: string
  ): RequestFormDTO {
    let listaFormularios: FormGroup[];
    let brand: string;
    let financialProduct: number;
    let intervinientes: ParticipantDTO[] = [];
    let requestSave: RequestFormDTO;
    let codOperative: string;
    const userName = this.credentialsService.credentials.username;

    console.log('requestype: ', request_type);
    switch (request_type) {
      case FORM_BP:
        listaFormularios = this.listaFormulariosBonpreu;
        brand = 'BP';
        financialProduct = 30;
        codOperative = 'BPU';
        break;
      case FORM_AUTO:
        listaFormularios = this.listaFormulariosAutos;
        brand = '';
        financialProduct = 20;
        codOperative = '';
        break;
      case FORM_CONSUMO:
        listaFormularios = this.listaFormulariosConsumo;
        brand = '';
        financialProduct = 1097;
        codOperative = '';
        break;
      case FORM_REPSOL:
        listaFormularios = this.listaFormulariosConsumo;
        financialProduct = 1097;
        codOperative = 'REP';
        brand = 'RE';
        break;
      case FORM_GS:
        listaFormularios = this.listaFormulariosConsumo;
        financialProduct = 10;
        codOperative = 'REP';
        brand = 'CG';
        break;
      case FORM_MG:
        listaFormularios = this.listaFormulariosMg;
        financialProduct = 30;
        codOperative = 'MNG';
        brand = 'MG';
        break;
      case FORM_MG_NO_SHOP:
        listaFormularios = this.listaFormulariosMgNoShopping;
        financialProduct = 30;
        codOperative = 'MNG';
        brand = 'MG';
        break;
      default:
        console.log('Tipo de alta no encontrado o imprimir');
    }
    if (this.numIntervinientes > 0 && (request_type === FORM_CONSUMO || request_type === FORM_AUTO)) {
      for (let index = 0, formularioInicial = INTERVINIENTE_1_HOLDER_DATA; index < this.numIntervinientes; index++) {
        console.log('FormularioInical: ' + formularioInicial);
        intervinientes[index] = this.ParticipantDTO(listaFormularios, formularioInicial);
        formularioInicial = formularioInicial + 4;
      }
    }
    requestSave = {
      accountHolding: listaFormularios[DIRECT_DEBIT].controls.ownershipCombo.value,
      addressNumber: listaFormularios[CONTACT_DATA].controls.number.value,
      amountCard:
        request_type === FORM_MG || request_type === FORM_MG_NO_SHOP || request_type === FORM_BP
          ? this.getAmountCard(listaFormularios)
          : listaFormularios[FINANCE_AMOUNT]?.controls.amount?.value
          ? listaFormularios[FINANCE_AMOUNT].controls.amount.value
          : listaFormularios[REQUEST_DATA]?.controls.amount?.value
          ? listaFormularios[REQUEST_DATA]?.controls.amount?.value
          : '',
      annualIngr:
        request_type == FORM_AUTO || request_type == FORM_CONSUMO
          ? listaFormularios[SOCIOECONOMIC_DATA].controls.incomeAnnual?.value?.slice(0, -1).trim()
          : '',
      antiquityProperty:
        (request_type == FORM_BP || request_type == FORM_MG || request_type == FORM_MG_NO_SHOP) &&
        listaFormularios[SOCIOECONOMIC_DATA].controls.livingAntiquity.value
          ? this.datePipe.transform(listaFormularios[SOCIOECONOMIC_DATA].controls.livingAntiquity.value, 'yyyy')
          : '',
      birthDate:
        listaFormularios[HOLDER_DATA].controls.birthDate.valid ||
        (listaFormularios[HOLDER_DATA].controls.birthDate.status === 'DISABLED' &&
          listaFormularios[HOLDER_DATA].controls.birthDate.value)
          ? this.datePipe.transform(listaFormularios[HOLDER_DATA].controls.birthDate.value, 'dd/MM/yyyy')
          : '',
      brand: brand,
      captacionCanal:
        request_type == FORM_BP && listaFormularios[POINT_OF_SALE].controls.inputChannel?.value
          ? listaFormularios[POINT_OF_SALE].controls.inputChannel?.value
          : request_type === FORM_MG
          ? 'AE'
          : request_type === FORM_MG_NO_SHOP
          ? listaFormularios[POINT_OF_SALE].controls.inputChannel?.value
            ? listaFormularios[POINT_OF_SALE].controls.inputChannel?.value
            : 'WS'
          : '',
      civilStatus: listaFormularios[HOLDER_DATA].controls.civilStatus.value,
      cnae: listaFormularios[SOCIOECONOMIC_DATA].controls.cnae.value,
      codEan13: '', //TODO: pendiente revisar con Paz, de momento vacío
      comDom: listaFormularios[CONTACT_DATA].controls.addressComplement.value,
      companyCif: listaFormularios[SOCIOECONOMIC_DATA].controls.nifOrCif?.value,
      companyName: listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseName.value?.toUpperCase(),
      companyPopulation: listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseProvince?.value
        ? listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseProvince.value.toUpperCase()
        : '',
      companySector: listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseActivity?.value,
      countryBirth: listaFormularios[HOLDER_DATA].controls.birthCountry.value,
      dateRequest: listaFormularios[POINT_OF_SALE].controls.requestDate.value
        ? this.datePipe.transform(listaFormularios[POINT_OF_SALE].controls.requestDate.value, 'dd/MM/yyyy')
        : '',
      documentId: listaFormularios[HOLDER_DATA].controls.nifNie.value?.toUpperCase(),
      digitalId:
        listaFormularios[HOLDER_DATA].controls?.checkVideoSelfing?.value === true &&
        this.videoSelfingID.getValue() == 'O'
          ? 'U'
          : listaFormularios[HOLDER_DATA].controls?.checkVideoSelfing?.value === true &&
            this.videoSelfingID.getValue() == 'S'
          ? 'S'
          : listaFormularios[HOLDER_DATA].controls?.checkVideoSelfing?.value === false &&
            this.videoSelfingID.getValue() == 'O'
          ? 'X'
          : listaFormularios[HOLDER_DATA].controls?.checkVideoSelfing?.value === true &&
            this.videoSelfingID.getValue() == 'U'
          ? 'U'
          : listaFormularios[HOLDER_DATA].controls?.checkVideoSelfing?.value === false &&
            this.videoSelfingID.getValue() == 'X'
          ? 'X'
          : listaFormularios[HOLDER_DATA].controls?.checkVideoSelfing?.value === false &&
            this.videoSelfingID.getValue() == 'DISABLED'
          ? 'X'
          : listaFormularios[HOLDER_DATA].controls?.checkVideoSelfing?.value === false &&
            this.videoSelfingID.getValue() == 'DISABLED_X'
          ? 'X'
          : listaFormularios[HOLDER_DATA].controls?.checkVideoSelfing?.value === false &&
            this.videoSelfingID.getValue() == 'ENABLED'
          ? 'X'
          : 'N',
      door: listaFormularios[CONTACT_DATA].controls.door.value,
      email: listaFormularios[CONTACT_DATA].controls.email.value,
      establishment: listaFormularios[POINT_OF_SALE].controls.establishment.value,
      expirationDay: listaFormularios[REQUEST_DATA].controls.expirationDay?.value
        ? listaFormularios[REQUEST_DATA].controls.expirationDay?.value
        : '', // 01 se envia para consumo preguntar a back el motivo
      expirationDate: listaFormularios[HOLDER_DATA].controls.nifNieExpiration.value
        ? this.datePipe.transform(listaFormularios[HOLDER_DATA].controls.nifNieExpiration.value, 'dd/MM/yyyy')
        : '',
      financialProduct: financialProduct,
      floor: listaFormularios[CONTACT_DATA].controls.floor.value,
      houseTel: listaFormularios[CONTACT_DATA].controls.additionalPhone.value,
      incomeNetos: listaFormularios[SOCIOECONOMIC_DATA].controls.incomeMonthly?.value?.slice(0, -1).trim(),
      incorpMonth: listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseAntiquity.value
        ? this.datePipe.transform(listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseAntiquity.value, 'MM')
        : '',
      incorpYear: listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseAntiquity.value
        ? this.datePipe.transform(listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseAntiquity.value, 'yyyy')
        : '',
      indAuthorization: dataDialogPass.autoriza,
      ingrMonthVble: listaFormularios[SOCIOECONOMIC_DATA].controls.incomeOther?.value?.slice(0, -1).trim(), // se cambia el campo insurance a S para el servicio de imprimir
      insurance: listaFormularios[INSURANCE]
        ? listaFormularios[INSURANCE].controls.insuranceSelect?.value
        : request_type == FORM_MG ||
          request_type === FORM_MG_NO_SHOP ||
          request_type === FORM_REPSOL ||
          request_type === FORM_GS
        ? ''
        : listaFormularios[FINANCE] && listaFormularios[FINANCE].controls.finance?.value?.insurance === '99'
        ? 'N'
        : 'S', //de momento sólo BP
      language: listaFormularios[POINT_OF_SALE].controls.requestLanguage?.value,
      mobileTel: listaFormularios[CONTACT_DATA].controls.phone.value,
      modPaymentCard: listaFormularios[REQUEST_DATA].controls.modality?.value
        ? listaFormularios[REQUEST_DATA].controls.modality?.value
        : '',
      name: listaFormularios[HOLDER_DATA].controls.name.value,
      nameAddress: listaFormularios[CONTACT_DATA].controls.address.value,
      // Desarrollo CTI
      // (listaFormularios[CONTACT_DATA].controls.trackType?.value === ''
      //   ? 'C'
      //   : listaFormularios[CONTACT_DATA].controls.trackType?.value) +
      // ' ' +
      nationality: listaFormularios[HOLDER_DATA].controls.nationality.value,
      noEmail: listaFormularios[CONTACT_DATA].controls.noemail.value,
      noMobile: listaFormularios[CONTACT_DATA].controls.nophone?.value,
      //TODO: TEST
      numOperation: this.numOperation
        ? this.numOperation
        : dataDialogPass?.numOperation
        ? dataDialogPass.numOperation
        : numOperation
        ? numOperation
        : '',
      observations: listaFormularios[REQUEST_OBSERVATIONS]
        ? listaFormularios[REQUEST_OBSERVATIONS].controls.observations.value
        : '',
      occupation: listaFormularios[SOCIOECONOMIC_DATA].controls.job.value,
      optionTest: this.optionTest ? this.optionTest : dataDialogPass?.optionTest ? dataDialogPass.optionTest : false,
      operative: {
        code: codOperative,
        user: listaFormularios[POINT_OF_SALE].controls.establishment.value?.slice(0, -1),
      },
      optionTestAccept: this.optionTestAccept
        ? this.optionTestAccept
        : dataDialogPass?.exigencias
        ? dataDialogPass.exigencias
        : '',
      password: dataDialogPass.password,
      peopleInCharge: listaFormularios[SOCIOECONOMIC_DATA].controls.peopleInCharge?.value
        ? listaFormularios[SOCIOECONOMIC_DATA].controls.peopleInCharge.value
        : '',
      postcode: listaFormularios[CONTACT_DATA].controls.postalCode.value,
      regime: '',
      secondSurname: listaFormularios[HOLDER_DATA].controls.surname2.value,
      sex: listaFormularios[HOLDER_DATA].controls.gender.value,
      sitVivienda: listaFormularios[SOCIOECONOMIC_DATA].controls.livingSituation.value,
      subSit: '',
      surname: listaFormularios[HOLDER_DATA].controls.surname1.value,
      telCompany: listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseTelephone?.value,
      town: listaFormularios[CONTACT_DATA].controls.town.value,
      user: userName,
      vendor:
        typeof listaFormularios[POINT_OF_SALE].controls.vendor.value === 'string'
          ? listaFormularios[POINT_OF_SALE].controls.vendor.value
          : listaFormularios[POINT_OF_SALE].controls.vendor.value.id,
      workSituation:
        request_type === FORM_REPSOL ? '01' : listaFormularios[SOCIOECONOMIC_DATA].controls.laboralSituation.value,
      //Datos bancarios
      iban: listaFormularios[DIRECT_DEBIT].controls.numberCreditAccount.value
        ? 'ES' + listaFormularios[DIRECT_DEBIT].controls.numberCreditAccount.value.substring(0, 2)
        : '',
      entityBank: listaFormularios[DIRECT_DEBIT].controls.numberCreditAccount.value
        ? listaFormularios[DIRECT_DEBIT].controls.numberCreditAccount.value.replace(/\s+/g, '').substring(2, 6)
        : '',
      officeBank: listaFormularios[DIRECT_DEBIT].controls.numberCreditAccount.value
        ? listaFormularios[DIRECT_DEBIT].controls.numberCreditAccount.value.replace(/\s+/g, '').substring(6, 10)
        : '',
      dcBank: listaFormularios[DIRECT_DEBIT].controls.numberCreditAccount.value
        ? listaFormularios[DIRECT_DEBIT].controls.numberCreditAccount.value.replace(/\s+/g, '').substring(10, 12)
        : '',
      numberBank: listaFormularios[DIRECT_DEBIT].controls.numberCreditAccount.value
        ? listaFormularios[DIRECT_DEBIT].controls.numberCreditAccount.value.replace(/\s+/g, '').substring(12, 22)
        : '',
      prescriberName: listaFormularios[PRESCRIBER_CONTACT_DATA]?.controls.prescriberName?.value,
      prescriberPhone: listaFormularios[PRESCRIBER_CONTACT_DATA]?.controls.prescriberPhone?.value,
      prescriberMail: listaFormularios[PRESCRIBER_CONTACT_DATA]?.controls.prescriberMail?.value,
      sitSol: hostStatus != null ? hostStatus : '',
    };

    //campos específicos de MG
    let requestSaveMG: any;
    if (request_type === FORM_MG || request_type === FORM_MG_NO_SHOP) {
      requestSaveMG = {
        ...requestSave,
        ...{
          customerMigrated: '', //??
          employeeCode: listaFormularios[POINT_OF_SALE].controls.employeeInternalRefMG.value,
          idStore: listaFormularios[POINT_OF_SALE].controls.idStoreMG.value,
          //sólo MG sin compra
          employeeMG: listaFormularios[POINT_OF_SALE].controls.employeeMG?.value
            ? listaFormularios[POINT_OF_SALE].controls.employeeMG.value
            : '',
        },
      };

      if (request_type === FORM_MG) {
        console.log(listaFormularios[REQUEST_DATA_MG].controls);
        requestSaveMG = {
          ...requestSaveMG,
          ...{
            amount: listaFormularios[REQUEST_DATA_MG].controls.requestedAmount.value?.substring(
              0,
              listaFormularios[REQUEST_DATA_MG].controls.requestedAmount.value?.length - 2
            ),
            commercialProduct: listaFormularios[REQUEST_DATA_MG].controls.commercialProduct.value,
            discountCodeWelcome: '', //TODO: vendrá en la respuesta de la calculadora y lo tendremos que enviar
            discountPercentage:
              listaFormularios[FINANCE].controls.discountPercentage?.value?.length <= 6
                ? '0' + listaFormularios[FINANCE].controls.discountPercentage?.value
                : listaFormularios[FINANCE].controls.discountPercentage?.value,
            discountWelcome: listaFormularios[FINANCE].controls.discountWelcome?.value,
            endContractDate: listaFormularios[FINANCE].controls.endContractDate?.value,
            formPayment: listaFormularios[REQUEST_DATA_MG].controls.formPayment.value, //TODO: test
            netPurchaseAmount: listaFormularios[FINANCE].controls.netPurchaseAmount?.value,
            numPlaz: listaFormularios[REQUEST_DATA_MG].controls.term.value,
            product: listaFormularios[REQUEST_DATA_MG].controls.product.value,
            productLine: listaFormularios[REQUEST_DATA_MG].controls.lineProduct.value,
            tariffSelected: listaFormularios[REQUEST_DATA_MG].controls.tariffs.value,
            tin: '',
            feeAmount: listaFormularios[FINANCE].controls.feeAmount?.value,
            codeVerionOperative: this.codeVersionOperative ? this.codeVersionOperative : '',
          },
        };
      }
      return requestSaveMG;
    }

    //AQUÍ SE AÑADEN LOS ESPECÍFICOS DE CALCULADORA DE CONSUMO
    if (request_type === FORM_CONSUMO || request_type === FORM_REPSOL || request_type === FORM_GS) {
      let requestSaveConsumption: any = {
        ...requestSave,
        ...{
          category: listaFormularios[FINANCE_AMOUNT].controls.product.value,
          commercialProduct: listaFormularios[REQUEST_DATA].controls.commercialProduct.value,
          companyCity: listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseProvince.value
            ? listaFormularios[SOCIOECONOMIC_DATA].controls.enterpriseProvince.value.toUpperCase()
            : '', // preguntar porque es diferente a companyPopulation
          codpac: listaFormularios[FINANCE].controls.finance.value?.insurance,
          entryAmount: listaFormularios[FINANCE_AMOUNT].controls.start.value?.replace('€', '').trim(),
          endContractDate: listaFormularios[FINANCE].controls.expirationDate.value,
          feeAmount:
            listaFormularios[FINANCE].controls.finance.value != null &&
            listaFormularios[FINANCE].controls.finance.value['share']
              ? listaFormularios[FINANCE].controls.finance.value['share']
              : '',
          financedAmount: listaFormularios[FINANCE_AMOUNT].controls.requestedAmount.value?.replace('€', '').trim(),
          formPayment: listaFormularios[REQUEST_DATA].controls.formPayment.value,
          housingExpenses:
            listaFormularios[SOCIOECONOMIC_DATA].controls.livingExpenses.value?.slice(0, -1).trim() !== null &&
            listaFormularios[SOCIOECONOMIC_DATA].controls.livingExpenses.value?.slice(0, -1).trim() !== undefined &&
            listaFormularios[SOCIOECONOMIC_DATA].controls.livingExpenses.value?.slice(0, -1).trim() !== ''
              ? listaFormularios[SOCIOECONOMIC_DATA].controls.livingExpenses.value?.slice(0, -1).trim()
              : 0,
          instalmentsNumber:
            listaFormularios[FINANCE].controls.finance.value != null
              ? this.listaFormulariosConsumo[FINANCE].controls.finance.value['plazoSal']
              : '',
          insurancePremium:
            listaFormularios[FINANCE].controls.finance.value != null &&
            listaFormularios[FINANCE].controls.finance.value['primeSecure']
              ? listaFormularios[FINANCE].controls.finance.value['primeSecure']
              : '',
          methodOfPayment: listaFormularios[REQUEST_DATA].controls.formPayment.value, //request_type === FORM_CONSUMO || request_type === FORM_GS ? 'F' : 'R',
          openingCosts: listaFormularios[FINANCE].controls.finance.value?.openingCosts,
          participants: intervinientes,
          numPlaz: listaFormularios[REQUEST_DATA].controls.term.value,
          productLine: listaFormularios[FINANCE_AMOUNT].controls.lineProduct.value,
          productPrice: listaFormularios[FINANCE_AMOUNT].controls.priceProduct.value?.replace('€', '').trim(),
          originRevenues: listaFormularios[SOCIOECONOMIC_DATA].controls.originsRevenue.value,
          reference: listaFormularios[REQUEST_DATA].controls.reference?.value
            ? listaFormularios[REQUEST_DATA].controls.reference?.value
            : '',
          tariffSelected:
            listaFormularios[FINANCE].controls.finance.value != null &&
            listaFormularios[FINANCE].controls.finance.value['idTariff']
              ? listaFormularios[FINANCE].controls.finance.value['idTariff']
              : '',
          tin:
            listaFormularios[FINANCE].controls.finance.value != null &&
            listaFormularios[FINANCE].controls.finance.value['tin']
              ? listaFormularios[FINANCE].controls.finance.value['tin']
              : '',
        },
      };
      return requestSaveConsumption;
    }

    //AQUÍ SE AÑADEN LOS ESPECÍFICOS DE CALCULADORA DE AUTOS
    if (request_type === FORM_AUTO) {
      let requestSaveAutos: any = {
        ...requestSave,
        ...{
          amount: listaFormularios[REQUEST_DATA].controls.priceVehicle.value?.slice(0, -1).trim(),
          amountNetDatFind: '',
          antCarMonth: listaFormularios[REQUEST_DATA].controls.antCar.valid
            ? this.datePipe.transform(listaFormularios[REQUEST_DATA].controls.antCar.value, 'MM')
            : '',
          antCarYear: listaFormularios[REQUEST_DATA].controls.antCar.valid
            ? this.datePipe.transform(listaFormularios[REQUEST_DATA].controls.antCar.value, 'yyyy')
            : '',
          brandVehicle: listaFormularios[REQUEST_DATA].controls.brand.value,
          carRegistration: listaFormularios[REQUEST_DATA].controls.carRegistration.value,
          codpac: this.listaFormulariosAutos[FINANCE].controls.finance.value?.insurance,
          commercialProduct: listaFormularios[REQUEST_DATA].controls.commercialProduct.value,
          dateDatFinIndiv: this.getCurrentDate(), //TODO: Fecha del día de hoy MOCKED -> consultar con Paz, ¿debería ser el día de hoy que se recogen los datos financieros del cliente?
          endContractDate: listaFormularios[FINANCE].controls.expirationDate.value,
          entry: listaFormularios[REQUEST_DATA].controls.start.value?.slice(0, -1).trim(),
          financial: listaFormularios[REQUEST_DATA].controls.requestedAmount.value?.slice(0, -1).trim(),
          formPayment: listaFormularios[REQUEST_DATA].controls.formPayment.value,
          gasAper: '',
          housingExpenses:
            listaFormularios[SOCIOECONOMIC_DATA].controls.livingExpenses.value?.slice(0, -1).trim() !== null &&
            listaFormularios[SOCIOECONOMIC_DATA].controls.livingExpenses.value?.slice(0, -1).trim() !== undefined &&
            listaFormularios[SOCIOECONOMIC_DATA].controls.livingExpenses.value?.slice(0, -1).trim() !== ''
              ? listaFormularios[SOCIOECONOMIC_DATA].controls.livingExpenses.value?.slice(0, -1).trim()
              : 0,
          jobPosition: '',
          model: listaFormularios[REQUEST_DATA].controls.model.value,
          netPurchaseAmount: listaFormularios[REQUEST_DATA].controls.requestedAmount.value?.slice(0, -1).trim(),
          numPlaz: listaFormularios[REQUEST_DATA].controls.term.value,
          numRack: listaFormularios[REQUEST_DATA].controls.numRack.value,
          otherExpenses: '',
          originRevenues: listaFormularios[SOCIOECONOMIC_DATA].controls.originsRevenue.value,
          participants: intervinientes,
          premiumInsurance: this.listaFormulariosAutos[FINANCE].controls.finance.value?.primeSecure,
          product: financialProduct.toString(),
          quota: this.listaFormulariosAutos[FINANCE].controls.finance.value?.firstShare,
          statusRequest: '',
          tariffSelected: listaFormularios[REQUEST_DATA].controls.tariffs.value,
          tin: this.listaFormulariosAutos[FINANCE].controls.finance.value?.tin,
          typeVehicle: listaFormularios[REQUEST_DATA].controls.vehicleType.value,
          version: listaFormularios[REQUEST_DATA].controls.version.value,
          fuelType: listaFormularios[REQUEST_DATA].controls.fuelType.value,
          sitSol: hostStatus != null ? hostStatus : '',
        },
      };
      return requestSaveAutos;
    }

    return requestSave;
  }

  private getAmountCard(listaFormularios: FormGroup[]): string {
    //modalidad de pago cuota fija
    if (listaFormularios[REQUEST_DATA].controls.modality.value === '14') {
      //importe personalizado
      if (listaFormularios[REQUEST_DATA].controls.amountCard.value === 'Other') {
        return listaFormularios[REQUEST_DATA].controls.otherAmountCard.value.replace('€', '').trim();
      } else {
        return listaFormularios[REQUEST_DATA].controls.amountCard.value.concat(',00');
      }
    } else {
      return '';
    }
  }

  public saveRackAutos(request_type: string, dataDialogPass: any, numOperation: string) {
    let requestSave = this.convertFormToRequestFormDTO(request_type, dataDialogPass, numOperation);

    this.requestsApi.postSaveRackRequestAutos(requestSave).subscribe(
      (result: RequestDataReponseDTO) => {
        this.showDialogResponse(result, 'save_rack', dataDialogPass, request_type);
      },
      (error) => {
        if (error.error.numberOperation) this.numOperation = error.error.numberOperation;
        this.showDialogError(error.error.errorFeedback.errorMessage);
      }
    );
  }

  public saveAndSend(type: string, request_type: string, dataDialogPass: any, numOperation: string, sitSol?: string) {
    let request = this.convertFormToRequestFormDTO(request_type, dataDialogPass, numOperation, sitSol);

    if (request !== null) {
      if (request.email.trim() === '' && request.mobileTel.trim() === '' && request.digitalId === 'U') {
        this.showDialogError(
          'Se deben informar los campos Email y telefono ya que esta solicitud requiere Video-selfing'
        );
      } else {
        if (request && type === 'save') {
          if (this.marcaFormulario === 'AUTO') {
            this.requestsApi.postSaveRequestAutos(request).subscribe(
              (result: RequestDataReponseDTO) => {
                this.showDialogResponse(result, type, dataDialogPass, request_type);
              },
              (error) => {
                console.log('error: ', error);
                if (error.error.numberOperation) this.numOperation = error.error.numberOperation;
                this.showDialogError(error.error.errorFeedback.errorMessage);
              }
            );
          } else {
            this.requestsApi.postSaveRequest(request, request_type).subscribe(
              (result: RequestDataReponseDTO) => {
                this.showDialogResponse(result, type, dataDialogPass, request_type);
              },
              (error) => {
                console.log('error: ', error);
                if (error.error.numberOperation) this.numOperation = error.error.numberOperation;
                this.showDialogError(error.error.errorFeedback.errorMessage);
              }
            );
          }
        } else if (request && type === 'send') {
          if (this.marcaFormulario === 'AUTO') {
            this.requestsApi.postSendRequestAutos(request).subscribe(
              (result: RequestDataReponseDTO) => {
                this.showDialogResponse(result, type, dataDialogPass, request_type, sitSol);
              },
              (error) => {
                console.log('error: ', error);
                if (error.error.numberOperation) this.numOperation = error.error.numberOperation;
                this.showDialogError(error.error.errorFeedback.errorMessage);
              }
            );
          } else {
            this.requestsApi.postSendRequest(request, request_type).subscribe(
              (result: RequestDataReponseDTO) => {
                this.showDialogResponse(result, type, dataDialogPass, request_type);
              },
              (error) => {
                console.log('error: ', error);
                if (error.error.numberOperation) this.numOperation = error.error.numberOperation;
                this.showDialogError(error.error.errorFeedback.errorMessage);
              }
            );
          }
        }
      }
    }
  }

  private checkIfRackOrRegistrationIsEmpty(request: RequestFormDTO, result: RequestDataReponseDTO) {
    //Se comprueba si el vehiculo es nuevo, de ser así, solo el bastidor es necesario para firmar la solicitud
    if (request.typeVehicle.includes('00')) {
      result.rackIsEmpty = request.numRack === null || request.numRack === '';
      //sino es nuevo, tanto el bastidor como la matricula son obligatorios
    } else {
      result.rackIsEmpty = request.numRack === null || request.numRack === '';
      result.carRegIsEmpty = request.carRegistration === null || request.carRegistration === '';
    }
    return result;
  }

  public getTestRequest(type: string, request_type: string, dataDialogPass: any, numOperation: string) {
    let request = this.convertFormToRequestFormDTO(request_type, dataDialogPass, numOperation);
    this.requestsApi.postGetTestRequest(request).subscribe(
      (result: RequestDataReponseDTO) => {
        if (result.errorFeedback) {
          this.showDialogError(result.errorFeedback.errorMessage);
        } else {
          this.showDialogTest(result, type, dataDialogPass, request_type);
        }
      },
      (error) => {
        console.log('error: ', error);
        if (error.error.numberOperation) this.numOperation = error.error.numberOperation;
        this.showDialogError(error.error.errorFeedback.errorMessage);
      }
    );
  }

  private sendCaption(type: string, request_type: string, dataDialogPass: any, numOperation: string) {
    let request = this.convertFormToRequestFormDTO(request_type, dataDialogPass, numOperation);
    this.requestsApi.postSendRequest(request, request_type).subscribe(
      (result: RequestDataReponseDTO) => {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '90%';
        dialogConfig.maxWidth = '450px';
        dialogConfig.disableClose = true;
        dialogConfig.data = { text: result.errorFeedback.errorMessage, icon: 'icon-ic_circle_cross' };
        const dialog = this.dialog.open(ResponseDialogComponent, dialogConfig);

        dialog.afterClosed().subscribe(() => {
          this.showDialogSuccess(result, type);
        });
      },
      (error) => {
        console.log('error: ', error);
        if (error.error.numberOperation) this.numOperation = error.error.numberOperation;
        this.showDialogError(error.error.errorFeedback.errorMessage);
      }
    );
  }

  public printRequest(
    request_type: string,
    dataDialogPass: any,
    numOperation: string,
    dataDialogConfig?: MatDialogConfig
  ) {
    console.log('printRequest');
    if (dataDialogConfig) this.operative = dataDialogConfig.data.operative;
    // this.request = dataDialogConfig.data.request;

    if (
      request_type != FORM_AUTO &&
      request_type != FORM_CONSUMO &&
      !(request_type === FORM_REPSOL || request_type === FORM_GS)
    ) {
      let request = this.convertFormToRequestFormDTO(request_type, dataDialogPass, numOperation);

      this.printStore.printRequest(request, request_type).then(
        (result: RequestDataReponseDTO) => {
          this.showDialogResponse(result, 'print', dataDialogPass, request_type);
        },
        (error) => {
          if (error.error.numberOperation) this.numOperation = error.error.numberOperation;
          this.showDialogError(error.error.errorFeedback.errorMessage);
        }
      );
    } else {
      //TODO: llamar al antiguo print
      let request: any = this.convertFormToRequestFormDTO(request_type, dataDialogPass, numOperation);
      let filename: string = '';
      this.printStore.printRequest(request, request_type).then((result: RequestDataReponseDTO) => {
        filename = result.filename;
        if (result.errorFeedback) {
          this.clearTest();
          let errorDescription: string;

          if (result.errorFeedback.errorField) {
            errorDescription = this.translate.instant('dialog.response.textFormatError', {
              field: this.translate.instant(result.errorFeedback.errorField),
            });
          } else {
            errorDescription = result.errorFeedback.errorMessage;
          }

          this.showDialogError(errorDescription);
        } else {
          if (result.testDemands?.length > 0) {
            this.showDialogTest(result, 'print', dataDialogPass, request_type);
          } else {
            let codBrand: string = '';
            console.log('print papyrus');
            //llamada print papyrus
            this.numOperation = result.numberOperation;

            if (request_type === FORM_AUTO) {
              codBrand = BRAND_AUTOS;
            } else if (request_type === FORM_CONSUMO) {
              codBrand = BRAND_PAPYRUS_CONSUMO;
            } else if (request_type === FORM_REPSOL || request_type === FORM_GS) {
              codBrand = BRAND_PAPYRUS_CREDICUENTAS;
            }

            let printContract: PrintContractDTO = {
              bindOffer: 'N',
              coBrand: codBrand,
              codeOperative: request.operative.code,
              codeProduct: request.commercialProduct,
              dateEntry: request.dateRequest,
              isIne: 'S',
              language: request.language,
              notary: '',
              numOperation: result.numberOperation,
              versionContract: '',
              versionPolicy: '',
              authorization: '',
              printSecure: 'S',
              filename: filename,
            };
            this.printStore.printContract(printContract).then(
              (data) => {
                if (data) {
                  this.printStore.openPDFOnSuccess(
                    data,
                    result.numberOperation,
                    request.language,
                    '',
                    printContract,
                    request.documentId
                  );
                }
              },
              (error) => {
                console.log('error print: ', error);
                const dialogConfig = new MatDialogConfig();
                dialogConfig.width = '90%';
                dialogConfig.maxWidth = '450px';
                dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross' };
                this.dialog.open(ResponseDialogComponent, dialogConfig);
              }
            );
          } //fin llamada print papyrus
        }
      }); //TODO:fin llamada
    }
  }

  private clearTest(): void {
    //this.numOperation = '';
    this.setContactDataForm(null);
    this.optionTest = false;
    this.optionTestAccept = '';
  }

  private showDialogResponse(
    result: RequestDataReponseDTO,
    type: string,
    dataDialogPass: any,
    request_type: string,
    sitSol?: string
  ) {
    this.numOperation = result.numberOperation;

    if (result.errorFeedback) {
      if (type == 'print') this.clearTest();

      let errorDescription: string;

      if (result.errorFeedback.errorField) {
        errorDescription = this.translate.instant('dialog.response.textFormatError', {
          field: this.translate.instant(result.errorFeedback.errorField),
        });
      } else {
        errorDescription = result.errorFeedback.errorMessage;
      }

      this.showDialogError(errorDescription);
    } else {
      if (result.testDemands?.length > 0) {
        this.showDialogTest(result, type, dataDialogPass, request_type, sitSol);
      } else {
        if (type == 'print') {
          this.printStore.openPDFBinaryOnSuccess(result.pdfContent, result.numberOperation, result.filename);
        } else {
          this.showDialogSuccess(result, type);
        }
      }
    }
  }

  private showDialogSuccess(result: RequestDataReponseDTO, type: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    dialogConfig.disableClose = true;
    let textDialog: string;
    if (result.status === PENDIENTES_DE_DATOS) {
      textDialog = 'dialog.response.textSuccessSave';
    } else if (result.status === EN_ESTUDIO) {
      textDialog = 'dialog.response.textStudying';
    } else if (result.status === APROBADAS) {
      const rackIsEmpty = result.rackIsEmpty;
      const carRegIsEmpty = result.carRegIsEmpty;
      if (!rackIsEmpty && !carRegIsEmpty) {
        textDialog = 'dialog.response.textSuccess';
      } else if (rackIsEmpty && carRegIsEmpty) {
        textDialog = 'dialog.response.textSuccessWithoutRackAndRegistration';
      } else if (rackIsEmpty) {
        textDialog = 'dialog.response.textSuccessWithoutRack';
      } else if (carRegIsEmpty) {
        textDialog = 'dialog.response.textSuccessWithoutCarRegistration';
      }
    } else if (result.status === FIRMADAS) {
      textDialog = 'dialog.response.textSuccess';
    } else if (result.status === FIRMADAS || result.status === FIRMADAS_STATUS_75) {
      textDialog = 'dialog.response.textSigned';
    } else if (result.status === DENEGADAS) {
      textDialog = 'dialog.response.textDenied';
    } else {
      textDialog = 'dialog.response.textUnknown';
    }

    if (type === 'save_rack') {
      dialogConfig.data = {
        text: this.translate.instant('dialog.response.saverack', { solicitud: result?.numberOperation }),
        icon: 'icon-ic_circle_check',
      };
    } else {
      dialogConfig.data = {
        text: this.translate.instant(textDialog, { solicitud: result?.numberOperation }),
        icon: 'icon-ic_circle_check',
      };
    }

    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  private showDialogError(message: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '450px';
    dialogConfig.disableClose = true;

    console.log('showdialogerror', message);

    dialogConfig.data = { text: message, icon: 'icon-ic_circle_cross' };
    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  private showDialogTest(
    result: RequestDataReponseDTO,
    type: string,
    dataDialogPass: any,
    request_type: string,
    sitSol?: string
  ) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '90%';
    dialogConfig.maxWidth = '500px';
    dialogConfig.data = { text: result?.testDemands[result?.testDemands.length - 1].txt };

    const dialog = this.dialog.open(TestRequestDialogComponent, dialogConfig);

    dialog.afterClosed().subscribe((dataDialogExigencias: any) => {
      if (dataDialogExigencias?.exigencias === 'S') {
        dataDialogPass['optionTest'] = true;
        dataDialogPass['numOperation'] = result.numberOperation;
        dataDialogPass['exigencias'] = dataDialogExigencias?.exigencias;
        dataDialogPass['codeVerionOperative'] = dataDialogExigencias?.codeVerionOperative;

        console.log('Method: showDialogTest - dataDialogPass', dataDialogPass);

        if (type == 'print') {
          this.printRequest(request_type, dataDialogPass, result.numberOperation);
        } else if (type == 'saveBpMgWithAssurance') {
          this.sendCaption(type, request_type, dataDialogPass, result.numberOperation);
        } else {
          this.saveAndSend(type, request_type, dataDialogPass, result.numberOperation, sitSol);
        }
      }
    });
  }

  private ParticipantDTO(listaFormularios: FormGroup[], formularioInicialIntervinientes: number): ParticipantDTO {
    let participant: ParticipantDTO;
    participant = {
      accountHolding:
        listaFormularios[formularioInicialIntervinientes + 3].controls.ownershipCombo.value !== 'undefined'
          ? listaFormularios[formularioInicialIntervinientes + 3].controls.ownershipCombo.value
          : '',
      addressNumber: listaFormularios[formularioInicialIntervinientes + 1].controls.number.value,
      amountNetDatFind: '', //TODO: Importe neto dato (?) ?? Preguntar a Paz, la descripción es Importe Datos Financieros
      annualIngr: listaFormularios[formularioInicialIntervinientes + 2].controls.incomeAnnual.value
        ?.slice(0, -1)
        .trim(),
      antiquityProperty: listaFormularios[formularioInicialIntervinientes + 2].controls.enterpriseAntiquity.value
        ? this.datePipe.transform(
            listaFormularios[formularioInicialIntervinientes + 2].controls.enterpriseAntiquity.value,
            'yyyy'
          )
        : '',
      birthDate: listaFormularios[formularioInicialIntervinientes].controls.birthDate.value
        ? this.datePipe.transform(
            listaFormularios[formularioInicialIntervinientes].controls.birthDate.value,
            'dd/MM/yyyy'
          )
        : '',
      cnae: listaFormularios[formularioInicialIntervinientes + 2].controls.cnae.value,
      civilStatus: listaFormularios[formularioInicialIntervinientes].controls.civilStatus.value,
      // codEan13: '',
      comDom: listaFormularios[formularioInicialIntervinientes + 1].controls.addressComplement.value,
      companyCif: listaFormularios[formularioInicialIntervinientes + 2].controls.nifOrCif.value,
      companyName: listaFormularios[formularioInicialIntervinientes + 2].controls.enterpriseName.value?.toUpperCase(),
      companyPopulation: listaFormularios[formularioInicialIntervinientes + 2].controls.enterpriseProvince.value,
      companySector: listaFormularios[formularioInicialIntervinientes + 2].controls.enterpriseActivity.value,
      countryBirth: listaFormularios[formularioInicialIntervinientes].controls.birthCountry.value,
      dateDatFinIndiv: this.getCurrentDate(),
      dcBank: listaFormularios[formularioInicialIntervinientes + 3].controls.numberCreditAccount.value
        ? listaFormularios[formularioInicialIntervinientes + 3].controls.numberCreditAccount.value
            .replace(/\s+/g, '')
            .substring(10, 12)
        : '',
      documentId: listaFormularios[formularioInicialIntervinientes].controls.nifNie.value?.toUpperCase(),
      door: listaFormularios[formularioInicialIntervinientes + 1].controls.door.value,
      email: listaFormularios[formularioInicialIntervinientes + 1].controls.email.value,
      endContractDate: listaFormularios[FINANCE].controls.expirationDate.value,
      entityBank: listaFormularios[formularioInicialIntervinientes + 3].controls.numberCreditAccount.value
        ? listaFormularios[formularioInicialIntervinientes + 3].controls.numberCreditAccount.value
            .replace(/\s+/g, '')
            .substring(2, 6)
        : '',
      expirationDate: listaFormularios[formularioInicialIntervinientes].controls.nifNieExpiration.value
        ? this.datePipe.transform(
            listaFormularios[formularioInicialIntervinientes].controls.nifNieExpiration.value,
            'dd/MM/yyyy'
          )
        : '',
      floor: listaFormularios[formularioInicialIntervinientes + 1].controls.floor.value,
      houseTel: listaFormularios[formularioInicialIntervinientes + 1].controls.additionalPhone.value,
      housingExpenses:
        listaFormularios[formularioInicialIntervinientes + 2].controls.livingExpenses.value?.slice(0, -1).trim() !==
          null &&
        listaFormularios[formularioInicialIntervinientes + 2].controls.livingExpenses.value?.slice(0, -1).trim() !==
          undefined &&
        listaFormularios[formularioInicialIntervinientes + 2].controls.livingExpenses.value?.slice(0, -1).trim() !== ''
          ? listaFormularios[formularioInicialIntervinientes + 2].controls.livingExpenses.value?.slice(0, -1).trim()
          : 0,
      iban: listaFormularios[formularioInicialIntervinientes + 3].controls.numberCreditAccount.value
        ? 'ES' +
          listaFormularios[formularioInicialIntervinientes + 3].controls.numberCreditAccount?.value
            .replace(/\s+/g, '')
            .substring(0, 2)
        : '',
      incomeNetos: listaFormularios[formularioInicialIntervinientes + 2].controls.incomeMonthly.value
        ?.slice(0, -1)
        .trim(),
      incorpMonth: listaFormularios[formularioInicialIntervinientes + 2].controls.enterpriseAntiquity.value
        ? this.datePipe.transform(
            listaFormularios[formularioInicialIntervinientes + 2].controls.enterpriseAntiquity.value,
            'MM'
          )
        : '',
      incorpYear: listaFormularios[formularioInicialIntervinientes + 2].controls.enterpriseAntiquity.value
        ? this.datePipe.transform(
            listaFormularios[formularioInicialIntervinientes + 2].controls.enterpriseAntiquity.value,
            'yyyy'
          )
        : '',
      indAuthorization: 'S',
      ingrMonthVble: listaFormularios[formularioInicialIntervinientes + 2].controls.incomeOther.value
        ?.slice(0, -1)
        .trim(),
      insurance: 'S', //Seguro - [S] Sí / [N] No ??
      jobPosition: '',
      mobileTel: listaFormularios[formularioInicialIntervinientes + 1].controls.phone.value,
      amountCard: '',
      modPaymentCard: '',
      name: listaFormularios[formularioInicialIntervinientes].controls.name.value,
      nameAddress: listaFormularios[formularioInicialIntervinientes + 1].controls.address.value,
      // Desarrollo CTI
      // (listaFormularios[formularioInicialIntervinientes + 1].controls.trackType.value === ''
      //   ? 'C'
      //   : listaFormularios[formularioInicialIntervinientes + 1].controls.trackType.value) +
      // ' ' +
      noEmail: listaFormularios[formularioInicialIntervinientes + 1].controls.noemail.value,
      noMobile: listaFormularios[formularioInicialIntervinientes + 1].controls.nophone?.value,
      nationality: listaFormularios[formularioInicialIntervinientes].controls.nationality.value,
      numberBank: listaFormularios[formularioInicialIntervinientes + 3].controls.numberCreditAccount.value
        ? listaFormularios[formularioInicialIntervinientes + 3].controls.numberCreditAccount.value
            .replace(/\s+/g, '')
            .substring(12, 22)
        : '',
      observations: '',
      occupation: listaFormularios[formularioInicialIntervinientes + 2].controls.job.value,
      officeBank: listaFormularios[formularioInicialIntervinientes + 3].controls.numberCreditAccount.value
        ? listaFormularios[formularioInicialIntervinientes + 3].controls.numberCreditAccount.value
            .replace(/\s+/g, '')
            .substring(6, 10)
        : '',
      originRevenues: listaFormularios[formularioInicialIntervinientes + 2].controls.originsRevenue.value,
      otherExpenses: '',
      postcode: listaFormularios[formularioInicialIntervinientes + 1].controls.postalCode.value,
      relationHolder: listaFormularios[formularioInicialIntervinientes].controls.relationHolder.value,
      secondSurname: listaFormularios[formularioInicialIntervinientes].controls.surname2.value,
      sex: listaFormularios[formularioInicialIntervinientes].controls.gender.value,
      sitVivienda: listaFormularios[formularioInicialIntervinientes + 2].controls.livingSituation.value,
      subSit: '',
      surname: listaFormularios[formularioInicialIntervinientes].controls.surname1.value,
      telCompany: listaFormularios[formularioInicialIntervinientes + 2].controls.enterpriseTelephone.value,
      town: listaFormularios[formularioInicialIntervinientes + 1].controls.town.value,
      typeCoHolder: listaFormularios[formularioInicialIntervinientes].controls.holderAccount?.value,
      workSituation: listaFormularios[formularioInicialIntervinientes + 2].controls.laboralSituation.value,
    };

    return participant;
  }

  private getCurrentDate() {
    let date = new Date();

    return date.getDate() + '/' + (date.getMonth() + 1).toString().padStart(2, '0') + '/' + date.getFullYear();
  }

  sendIC(dataDialogPass: any) {
    const userName = this.credentialsService.credentials.username;
    let requestIC: RequestFormInstantCreditDTO;

    //recoger los datos de consumo y enviarlos al servicio de IC

    requestIC = {
      productPrice: this.listaFormulariosConsumo[FINANCE_AMOUNT].controls.priceProduct.value?.replace('€', '').trim(),
      financedAmount: this.listaFormulariosConsumo[FINANCE_AMOUNT].controls.requestedAmount.value
        ?.replace('€', '')
        .trim(),
      entryAmount: this.listaFormulariosConsumo[FINANCE_AMOUNT].controls.start.value?.replace('€', '').trim(),
      instalmentsNumber: this.listaFormulariosConsumo[FINANCE].controls.finance.value['plazoSal'],
      feeAmount: this.listaFormulariosConsumo[FINANCE].controls.finance.value['share']
        ? this.listaFormulariosConsumo[FINANCE].controls.finance.value['share']
        : '',
      insurancePremium: this.listaFormulariosConsumo[FINANCE].controls.finance.value['primeSecure']
        ? this.listaFormulariosConsumo[FINANCE].controls.finance.value['primeSecure']
        : '',
      openingCosts: this.listaFormulariosConsumo[FINANCE].controls.finance.value.openingCosts,
      reference: this.listaFormulariosConsumo[REQUEST_DATA].controls.reference?.value
        ? this.listaFormulariosConsumo[REQUEST_DATA].controls.reference?.value
        : '',
      tariffSelected: this.listaFormulariosConsumo[REQUEST_DATA].controls.tariffs.value,
      numPlaz: this.listaFormulariosConsumo[FINANCE].controls.finance.value['plazoSal'],
      formPayment: this.listaFormulariosConsumo[REQUEST_DATA].controls.formPayment.value,
      commercialProduct: this.listaFormulariosConsumo[REQUEST_DATA].controls.commercialProduct.value,
      product: this.listaFormulariosConsumo[FINANCE_AMOUNT].controls.product.value,
      amount: this.listaFormulariosConsumo[FINANCE_AMOUNT].controls.requestedAmount.value?.slice(0, -1).trim(),
      tin: this.listaFormulariosConsumo[FINANCE].controls.finance.value['tin']
        ? this.listaFormulariosConsumo[FINANCE].controls.finance.value['tin']
        : '',
      productLine: this.listaFormulariosConsumo[FINANCE_AMOUNT].controls.lineProduct.value,
      numOperation: this.numOperationIC,
      user: userName,
      password: dataDialogPass?.password,
      financialProduct: 10,
      establishment: this.listaFormulariosConsumo[POINT_OF_SALE].controls.establishment.value,
      dateRequest: this.listaFormulariosConsumo[POINT_OF_SALE].controls.requestDate.value
        ? this.datePipe.transform(this.listaFormulariosConsumo[POINT_OF_SALE].controls.requestDate.value, 'dd/MM/yyyy')
        : '',
      vendor:
        typeof this.listaFormulariosConsumo[POINT_OF_SALE].controls.vendor.value === 'string'
          ? this.listaFormulariosConsumo[POINT_OF_SALE].controls.vendor.value
          : this.listaFormulariosConsumo[POINT_OF_SALE].controls.vendor.value?.id,
      language: this.listaFormulariosConsumo[POINT_OF_SALE].controls.requestLanguage?.value,
      expirationDay: this.listaFormulariosConsumo[REQUEST_DATA].controls.expirationDay?.value
        ? this.listaFormulariosConsumo[REQUEST_DATA].controls.expirationDay?.value
        : '',
      expirationDayName: '',
      codpac: this.listaFormulariosConsumo[FINANCE].controls.finance.value.insurance,
      name: this.listaFormulariosConsumo[REQUEST_BASIC_CONTACT].controls.name.value,
      surname: this.listaFormulariosConsumo[REQUEST_BASIC_CONTACT].controls.middleName.value,
      secondSurname: this.listaFormulariosConsumo[REQUEST_BASIC_CONTACT].controls.surname.value,
      mobileTel: this.listaFormulariosConsumo[REQUEST_BASIC_CONTACT].controls.telephone.value,
      email: this.listaFormulariosConsumo[REQUEST_BASIC_CONTACT].controls.email.value,
      documentId: this.listaFormulariosConsumo[REQUEST_BASIC_CONTACT].controls.nif.value,
      errorField: '',
      sendEmail: dataDialogPass.typeLink === 'email' ? true : false,
      prescriberName: this.listaFormulariosConsumo[PRESCRIBER_CONTACT_DATA].controls.prescriberName?.value,
      prescriberPhone: this.listaFormulariosConsumo[PRESCRIBER_CONTACT_DATA].controls.prescriberPhone?.value,
      prescriberMail: this.listaFormulariosConsumo[PRESCRIBER_CONTACT_DATA].controls.prescriberMail?.value,
    };

    this.requestsApi.postSendRequestIC(requestIC).subscribe(
      (result: RequestDataReponseDTO) => {
        console.log(requestIC);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '90%';
        dialogConfig.maxWidth = '450px';
        dialogConfig.disableClose = true;
        dialogConfig.data = {
          title: 'dialog.title.IC',
          text: this.translate.instant('dialog.response.IC', { field: result.numberOperation }),
          icon: 'icon-ic_circle_check',
        };
        this.dialog.open(ResponseDialogComponent, dialogConfig);
        this.numOperationIC = '';
      },
      (error) => {
        if (error.error.numberOperation) {
          this.numOperationIC = error.error.numberOperation;
          this.numOperation = error.error.numberOperation;
        }
        this.showDialogError(error.error.errorFeedback.errorMessage);
      }
    );
  }

  downloadPapyrus(
    isAuto: boolean,
    mode: string,
    request: any,
    operative: string,
    request_type?: string,
    operation?: Operation,
    passwordForm?: FormGroup
  ) {
    const operationMapper: any = operation;
    let cobrand = '';
    let form: FormGroup[] = null;
    let AuthorizationPapyrus: AuthorizationPapyrusDTO;

    let comercialProduct = form ? form[REQUEST_DATA].controls.commercialProduct.value : request?.commercialProduct;

    comercialProduct = (comercialProduct as string).slice(0, 2);
    if (comercialProduct === FINANCIAL_PRODUCT.CONSTANTE_PRODUCTO_FINANCIERO_AUTOS) {
      cobrand = BRAND_AUTOS;
      if (mode === 'new') {
        form = this.listaFormulariosAutos;
      }
    } else if (comercialProduct === FINANCIAL_PRODUCT.CONSTANTE_PRODUCTO_FINANCIERO_CONSUMO) {
      cobrand = BRAND_PAPYRUS_CONSUMO;
      if (mode === 'new') {
        form = this.listaFormulariosConsumo;
      }
    } else if (comercialProduct === FINANCIAL_PRODUCT.CONSTANTE_PRODUCTO_FINANCIERO_TARJETAS) {
      cobrand = BRAND_PAPYRUS_CREDICUENTAS;
      if (mode === 'new') {
        form = this.listaFormulariosConsumo;
      }
    } else if (comercialProduct === FINANCIAL_PRODUCT.CONSTANTE_PRODUCTO_FINANCIERO_PRESTAMOS) {
      if (operationMapper.versionContract === VERSION_PRESTAMO_REESTRUCTURADO) {
        cobrand = BRAND_PAPYRUS_PRESTAMO_REESTRUCTURADO;
      } else {
        cobrand = BRAND_PAPYRUS_PRESTAMO_PERSONAL;
      }
      if (mode === 'new') {
        form = this.listaFormulariosAutos;
      }
    } else if (comercialProduct === FINANCIAL_PRODUCT.CONSTANTE_PRODUCTO_FINANCIERO_LEASING) {
      cobrand = BRAND_AUTOS_LEASING;
    }

    let RequestdataContract: AuthorizationDTO;

    // let dataContract: RequestFormDTO;
    // dataContract = this.convertFormToRequestFormDTO(request_type, {
    //   password: passwordForm ? passwordForm.controls.password.value : '',
    //   autoriza: passwordForm ? passwordForm.controls.checkObservations.value : 'S',
    // });

    RequestdataContract = this.printStore.convertAuthorizationToHolderDTO(request, false);

    AuthorizationPapyrus = {
      holderDTO: RequestdataContract.holderDTO,
      participants: RequestdataContract.participants,
    };

    let printContract: PrintContractDTO = {
      bindOffer: 'N',
      coBrand: cobrand,
      codeOperative: operative,
      codeProduct: comercialProduct,
      dateEntry: form
        ? this.datePipe.transform(form[POINT_OF_SALE].controls.requestDate.value, 'dd/MM/yyyy')
        : request?.dateRequest,
      isIne: '',
      language: form ? form[POINT_OF_SALE].controls.requestLanguage?.value : request?.language,
      notary: '',
      numOperation: request?.numOperation ? request.numOperation : '',
      versionContract: operationMapper?.versionContract ? operationMapper?.versionContract : '',
      versionPolicy: '',
      authorization: 'S',
      dataContract: AuthorizationPapyrus,
    };

    this.printStore.printContract(printContract).then(
      (data) => {
        if (data) {
          this.printStore.openPDFOnSuccess(
            data,
            request?.numOperation,
            request?.language,
            '',
            printContract,
            request?.documentId,
            true
          );
        }
      },
      (error) => {
        console.log('error print: ', error);
        const dialogConfig = new MatDialogConfig();
        dialogConfig.width = '90%';
        dialogConfig.maxWidth = '450px';
        dialogConfig.data = { text: error, icon: 'icon-ic_circle_cross' };
        this.dialog.open(ResponseDialogComponent, dialogConfig);
      }
    );
  }
}
